import { render, staticRenderFns } from "./HandleRedirects.vue?vue&type=template&id=aaa4d946&"
import script from "./HandleRedirects.vue?vue&type=script&lang=ts&"
export * from "./HandleRedirects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports